<!-- Communications are called Announcements in the UI -->

<div class="container">
  <div class="header">
    <div>
      <h1 mat-dialog-title *ngIf="localeService.getLocale() == 'en-CA'">
        {{ communication.englishTitle }}
      </h1>
      <h1 mat-dialog-title *ngIf="localeService.getLocale() == 'fr-CA'">
        {{ communication.frenchTitle }}
      </h1>
    </div>
    <div>
      {{ 'Communications.PublishedOn' | translate }}
      {{ communication.publishDate | kortoDate }}
    </div>
  </div>

  <mat-dialog-content
    *ngIf="localeService.getLocale() == 'en-CA'"
    [innerHTML]="communication.englishBody"
  ></mat-dialog-content>

  <mat-dialog-content
    *ngIf="localeService.getLocale() == 'fr-CA'"
    [innerHTML]="communication.frenchBody"
  ></mat-dialog-content>
  <div class="spacer"></div>
  <mat-dialog-actions align="end">
    <button class="btn btn-primary btn-sm" mat-dialog-close>
      {{ 'Communications.CloseDialog' | translate }}
    </button>
  </mat-dialog-actions>
</div>
